import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Conclusions = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Conclusion</Paragraph>
        <Text className='BaseText2'>In conclusion we visualize iMoAge to be implemented as Point of Care biosensor that could be useful to the geriatric field.After finishing the proof of concept and prototype stage, approving all the legislations required and guaranteeing that iMoAge is a safety device we hope that the health institutions of our country implement this novel technology in the Mexican population.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Conclusions;
